import { OnboardingStepProps as OnboardingStepPropsSource } from "./OnboardingNUX.d";

export type OnboardingStepProps = OnboardingStepPropsSource;

export { OnboardingStep } from "./OnboardingNUX.d";
export { OnboardingNUX } from "./OnboardingNUX.loadable";
export * from "./OnboardingNUX.styles";
